// extracted by mini-css-extract-plugin
export default {"button":"ButtonScroll_button__PQkQt","button_prevented-pointer":"ButtonScroll_button_prevented-pointer__RAQyh"};